export default __webpack_public_path__ + "static/media/pricing.97681583.gif";